export class WebCliente {
    idCliente : number
    nmCliente: string
}